import { API, authClient } from "../index";

// Get all peticiones
export const getPeticiones = () => {
  return authClient().get(`${API}/peticion?getDisabled=true`);
};

// Get peticion by id
export const getPeticionById = (id) => {
  return authClient().get(`${API}/peticion/${id}`);
};

// Delete peticion
export const deletePeticion = (id) => {
  return authClient().delete(`${API}/peticion/${id}`);
};

// Create peticion
export const postPeticion = async (peticion) => {
  return authClient().post(`${API}/peticion`, peticion);
};

// Update peticion
export const updatePeticion = async (id, peticion) => {
  return authClient().put(`${API}/peticion/${id}`, peticion);
};

// Change status peticion
export const changeStatusPeticion = async (id, active) => {
  return authClient().put(`${API}/peticion/change-status/${id}`, { active });
};
